// extracted by mini-css-extract-plugin
export var defaultWrapper = "_hq-3";
export var downloadButton = "_hq-4";
export var fileContainer = "_hq-9 _hq-7";
export var fileContainerBase = "_hq-7";
export var fileContainerFixedHeight = "_hq-8 _hq-7";
export var fileInfo = "_hq-5";
export var fileInfoWidthRestricted = "_hq-6";
export var fileType = "_hq-1";
export var fileTypeName = "_hq-2";
export var image = "_hq-0";
export var link = "_hq-b";
export var overflowEllipsis = "_hq-a";